var _circle, _g, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGotoWaypoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 256,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "orange"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462,290c-18.7,0-34-15.3-34-34s15.3-34,34-34s34,15.3,34,34S480.7,290,462,290 M462,306c27.6,0,50-22.4,50-50 s-22.4-50-50-50s-50,22.4-50,50S434.4,306,462,306L462,306z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.7,
    y: 241,
    width: 138,
    height: 30
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "361.8,256 285.6,300 285.6,212 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGotoWaypoint);
export default __webpack_public_path__ + "static/media/icon_gotoWaypoint.cab07663c8d15664f2c5d3aebc63008d.svg";
export { ForwardRef as ReactComponent };